/* istanbul ignore file reason: TODO */

import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FirebaseConfig } from '@ionic-native/firebase-config/ngx';
import { Deploy } from 'cordova-plugin-ionic/dist/ngx';
import { UpdateAppService, UpdateAppConfig } from './update-app.service';
import { IonicModule } from '@ionic/angular';
import { Market } from '@ionic-native/market/ngx';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [],
  imports: [CommonModule, IonicModule, RouterModule],
})
export class UpdateAppModule {
  static forRoot(config: UpdateAppConfig): ModuleWithProviders<UpdateAppModule> {
    return {
      ngModule: UpdateAppModule,
      providers: [UpdateAppService, FirebaseConfig, Deploy, Market, { provide: UpdateAppConfig, useValue: config }],
    };
  }
}
